export const auth0Config = {
    clientId: process.env.AUTH0_CLIENT_ID || 'tDtWo3yVMaRlclxEc4me1u9mPjLtDQmG',
    domain: process.env.AUTH0_DOMAIN || 'variocube.eu.auth0.com',
    audience: process.env.AUTH0_AUDIENCE || 'https://vending.variocube.com/',
};
